import Routes from "@navigations/Routes";
import { isEmbeddedFrame, postIframeLayout } from "@utils/iframeMessaging";
import {
  measureActiveContentHeight,
  measureElementDocumentHeight,
} from "./contentBounds";

const MIN_CHANGE = 4;
const FIND_MATCH_ROOT_ID = "iframe-find-match-root";

const measureFindMatchHeight = () => {
  const root = document.getElementById(FIND_MATCH_ROOT_ID);
  if (!root) return measureActiveContentHeight();
  return measureElementDocumentHeight(root);
};

export const initializeFindMatchHeight = () => {
  if (!isEmbeddedFrame()) return () => undefined;

  let active = true;
  let lastPosted = 0;
  let frameId = 0;

  const publish = () => {
    if (!active) return;
    const height = measureFindMatchHeight();
    if (height <= 0 || Math.abs(height - lastPosted) < MIN_CHANGE) return;
    lastPosted = height;
    postIframeLayout({
      mode: "auto-height",
      route: Routes.FindMatchScreen,
      height,
    });
  };

  const schedule = () => {
    cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(publish);
  };

  const observer = new MutationObserver(schedule);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener("resize", schedule);
  schedule();

  return () => {
    active = false;
    cancelAnimationFrame(frameId);
    observer.disconnect();
    window.removeEventListener("resize", schedule);
  };
};

export const cleanupFindMatchHeight = (cleanup: () => void) => cleanup();
